import { useState } from 'react';
import { Modal } from '@/components/molecules';
import { WarehouseForm, WarehouseList } from '@/components/organisms/Warehouse';
import type { Warehouse } from '@/schemas/warehouse';

export default function WarehousesPage() {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState<Warehouse | null>(null);

  const handleCreateClick = () => {
    setIsAddModalOpen(true);
  };

  const handleEditClick = (warehouse: Warehouse) => {
    setSelectedWarehouse(warehouse);
    setIsEditModalOpen(true);
  };

  const handleFormSuccess = () => {
    setIsAddModalOpen(false);
    setIsEditModalOpen(false);
    setSelectedWarehouse(null);
    // Trigger a refetch by closing the modal
  };

  return (
    <div>
      <WarehouseList onCreateClick={handleCreateClick} onEditClick={handleEditClick} />

      <Modal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        title="Create New Warehouse"
        size="lg"
      >
        <WarehouseForm onSuccess={handleFormSuccess} onCancel={() => setIsAddModalOpen(false)} />
      </Modal>

      <Modal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setSelectedWarehouse(null);
        }}
        title="Edit Warehouse"
        size="lg"
      >
        {selectedWarehouse && (
          <WarehouseForm
            initialData={selectedWarehouse}
            onSuccess={handleFormSuccess}
            onCancel={() => {
              setIsEditModalOpen(false);
              setSelectedWarehouse(null);
            }}
          />
        )}
      </Modal>
    </div>
  );
}
